const LOGO_WITHOUT_NAME_HEADER = function () {
  $(".text-logo-banner")?.hide();
  if ($(window).width() >= 1280) {
    $(".header__heading-logo-wrapper").css("width", "88px");
  } else if ($(window).width() >= 768) {
    $(".header__heading-logo-wrapper").css("width", "64px");
  } else {
    $(".header__heading-logo-wrapper").css("width", "48px");
  }
};

const LOGO_WITH_NAME_HEADER = function () {
  $(".text-logo-banner")?.show();
  if ($(window).width() >= 1280) {
    $(".header__heading-logo-wrapper").css("width", "64px");
  } else if ($(window).width() >= 768) {
    $(".header__heading-logo-wrapper").css("width", "44px");
  } else {
    $(".header__heading-logo-wrapper").css("width", "32px");
  }
};

const CONVERT_DROP_NAME = (name) => {
  return /^drop#\d+$/i.test(name)
    ? name.toLowerCase()
    : name.replace(/^[a-zA-Z]+(#\d+)$/i, "drop$1").toLowerCase();
};

// "730ml Bottle" / "+ 2,300ml Tritan Bottle" → "730ml" / "2300ml"; "" if no bottle.
// Matches the image names in fetchModelConfig.js (shirt_<COLOR>_bottle_<size>).
// Accepts old and new variant names too: "Small Bottle Added" → "730ml",
// "Large Bottle Added" → "2300ml", "No Bottle Added" / "None" → "".
const GET_BOTTLE_SIZE = function (text) {
  const down = String(text || "").toLowerCase();
  const compact = down.replace(/[,\s]/g, "");
  if (down.includes("no bottle")) return "";
  if (compact.includes("2300") || /\blarge\b/.test(down)) return "2300ml";
  if (compact.includes("730") || /\bsmall\b/.test(down)) return "730ml";
  return "";
};

const ADD_IMAGE_TO_ORDER_LINE = function (elementLoop, selector) {
  const titleProduct = $(elementLoop)
    .find(".cartItem__heading h2")
    .first()
    .text()
    .split(":")[0]
    .split(" ");

  const titleProduct2 = $(elementLoop)
    .find(".cartItem__heading h2")
    .first()
    .text()

  if (titleProduct.length == 2) {
    // Hoodie
    const numberDrop = titleProduct[0] + titleProduct[1];    

    const nameCoordColor = $(elementLoop)
      .find(".cartItem__heading h2 > div")
      .last()
      .text()
      .replace(' print', '');

    const modelUrl = getModelConfig(MODEL_CONFIG)?.modelUrl || URL_TEXTCOLOR_OPTIONS_OF_DROPS;
    const convertName = CONVERT_DROP_NAME(numberDrop);

    const urlDrop = modelUrl.find(
      (e) => e.name.toLowerCase() == convertName.toLowerCase()
    );

    if (nameCoordColor && urlDrop?.items) {
      const urlCoordColor = urlDrop.items.find(
        (e) => e.name.toLowerCase() == nameCoordColor.toLowerCase()
      );

      urlCoordColor && $(elementLoop).find(selector).prop("src", urlCoordColor?.url);
    }
  }

  if (titleProduct2 == "AKA'IKI SUMMER ESSENTIALS:") {
    // Shirt

    const printColor = $(elementLoop)
      .find(".cartItem__heading h2 > div")
      .last()
      .text()
      .replace(' print', '')
      .trim()
      .toUpperCase();

    const shirtColor = $(elementLoop)
      .find(".cartItem__heading h2 > div")
      .eq(1)
      .text()
      .split(' | ')[0]
      .trim()
      .toUpperCase();

    // Prefer the raw size from data-bottle-size (set in main-cart-items.liquid);
    // fall back to parsing the label, ignoring commas ("2,300ml" → "2300ml").
    const bundleEl = $(elementLoop).find(".cartItem__bundle").first();
    const bottleSize = bundleEl.attr("data-bottle-size")
      || GET_BOTTLE_SIZE(bundleEl.text());

    const modelUrl = getModelConfig(MODEL_CONFIG)?.modelUrl || URL_TEXTCOLOR_OPTIONS_OF_DROPS;
    const urlDrop = modelUrl.find((e) => e.name.toLowerCase() === "shirt");

    let fullName;
    if (bottleSize) {
      fullName = "shirt_" + shirtColor + "_bottle_" + bottleSize;
    } else {
      fullName = "shirt_" + shirtColor + "_print_" + printColor;
    }

    if (fullName && urlDrop?.items) {
      const urlCoordColor = urlDrop.items.find(
        (e) => e.name.toLowerCase() === fullName.toLowerCase()
      );

      urlCoordColor && $(elementLoop).find(selector).prop("src", urlCoordColor?.url);
    }
  }
};
